export const getStoreHandleFromHost = (host = '') => {
  const [storeHandle] = host.split('.')

  return storeHandle
}

export const clearHTMLTags = (str: string) => {
  return str.replace(/(<([^>]+)>)/gi, '')
}

export const toCammelCase = (str: string) => {
  return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (_, chr) => chr.toUpperCase())
}
